import { UnexpectedResponseStatusError } from '@/util/error';

const throwUnexpectedResponseError = (expectedStatus, response) => {
  let message = `Status "${expectedStatus}" erwartet, aber "${response.status} ${response.statusText}" erhalten`;

  if (response.data) {
    if (typeof response.data === 'string') {
      message = response.data;
    } else if (typeof response.data === 'object') {
      message = response.data.message
        || (typeof response.data.error === 'string' ? response.data.error : null)
        || (response.data.error && response.data.error.message)
        || message;
    }
  }

  throw new UnexpectedResponseStatusError(response, message);
};

const normalizeExpectedStatuses = (expectedStatus) => (
  Array.isArray(expectedStatus) ? expectedStatus : [expectedStatus]
);

const matchesExpectedStatus = (expectedStatus, response) => {
  const expected = normalizeExpectedStatuses(expectedStatus);

  if (expected.includes(response.status)) {
    return true;
  }

  // Legacy image APIs: HTTP 200 with semantic status in JSON body (`{ code: 204 }`).
  const bodyCode = response.data?.code;
  if (response.status === 200 && bodyCode != null && expected.includes(bodyCode)) {
    return true;
  }

  return false;
};

const checkResponseStatus = (expectedStatus, response) => {
  if (!matchesExpectedStatus(expectedStatus, response)) {
    const expected = normalizeExpectedStatuses(expectedStatus);
    const label = expected.length === 1 ? expected[0] : expected.join(' or ');
    throwUnexpectedResponseError(label, response);
  }
  return true;
};

export { checkResponseStatus };
